import { render, staticRenderFns } from "./AuthStepMFA.vue?vue&type=template&id=044a48da"
import script from "./AuthStepMFA.vue?vue&type=script&lang=ts"
export * from "./AuthStepMFA.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('044a48da')) {
      api.createRecord('044a48da', component.options)
    } else {
      api.reload('044a48da', component.options)
    }
    module.hot.accept("./AuthStepMFA.vue?vue&type=template&id=044a48da", function () {
      api.rerender('044a48da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/upload_tabs/aws/AuthStepMFA.vue"
export default component.exports